import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Database, Trash2 } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EnTete } from "@/components/commun";
import { Confirmer } from "@/components/migration/Confirmer";
import { Opportunites, Prevision, Annuel, EntonnoirTaux, VueGlobale, Productivite } from "@/components/tableaux/Indicateurs";

const Demo = ({ onMaj }) => {
  const [e, setE] = useState(null);
  const [occ, setOcc] = useState(false);
  const charger = useCallback(() => api.get("/demo-tableaux").then((r) => setE(r.data)), []);
  useEffect(() => { charger(); }, [charger]);
  const agir = async (url) => {
    setOcc(true);
    try { const r = await api.post(url); toast.success(r.data.message); setE(r.data); onMaj(); } catch (x) { toast.error(messageErreur(x)); } finally { setOcc(false); }
  };
  if (!e) return null;
  return (
    <div className="at-card p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="demo-panel">
      <p className="text-sm flex-1" data-testid="demo-state">{e.chargee ? `Jeu de démonstration chargé : ${e.fiches} fiches, ${e.appels} appels (marqués « Démo »).` : "Peu de données ? Chargez un jeu de démonstration effaçable."}</p>
      {e.chargee
        ? <div className="sm:w-auto"><Confirmer titre="Mettre la démo à la corbeille ?" texte={`Les ${e.fiches} fiches et ${e.appels} appels de démonstration partent à la corbeille (restaurables 30 jours).`} testId="demo-remove" onOk={() => agir("/demo-tableaux/retirer")}><Trash2 size={16} />Mettre la démo à la corbeille</Confirmer></div>
        : <button type="button" disabled={occ} onClick={() => agir("/demo-tableaux/charger")} className="at-btn at-btn-primary" data-testid="demo-load-button"><Database size={16} />Charger la démo</button>}
    </div>
  );
};

export default function TableauxDeBord() {
  const { user } = useAuth();
  const [periode, setPeriode] = useState("mois");
  const [perProd, setPerProd] = useState("jour");
  const [d, setD] = useState(null);
  const [prod, setProd] = useState(null);
  const [cle, setCle] = useState(0);
  const [histo, setHisto] = useState(false);
  const voitProd = ["dirigeant", "responsable", "agent"].includes(user.role);
  useEffect(() => { api.get("/tableaux/commun", { params: { periode, historique: histo } }).then((r) => setD(r.data)).catch((x) => toast.error(messageErreur(x))); }, [periode, cle, histo]);
  useEffect(() => { if (voitProd) api.get("/tableaux/productivite", { params: { periode: perProd, historique: histo } }).then((r) => setProd(r.data)); }, [perProd, cle, voitProd, histo]);
  return (
    <div className="space-y-4" data-testid="page-dashboards">
      <EnTete titre="Tableaux de bord" sousTitre="Chiffres limités à votre périmètre" />
      {user.role === "dirigeant" && <Demo onMaj={() => setCle((k) => k + 1)} />}
      <label className="at-card px-4 min-h-[44px] flex items-center gap-2 text-sm cursor-pointer w-fit" data-testid="dashboards-history-toggle">
        <input type="checkbox" checked={histo} onChange={(e) => setHisto(e.target.checked)} className="w-5 h-5" data-testid="dashboards-history-checkbox" />Inclure l'historique noCRM
      </label>
      {!d ? <p className="at-muted text-sm" data-testid="dashboards-loading">Chargement…</p> : (
        <div className="grid lg:grid-cols-2 gap-4">
          <Opportunites o={d.opportunites} />
          <Prevision p={d.prevision} />
          <EntonnoirTaux etapes={d.entonnoir} periode={periode} setPeriode={setPeriode} />
          <Annuel annuel={d.annuel} annee={d.annee} />
          <div className="lg:col-span-2 min-w-0"><VueGlobale v={d.processus} /></div>
          {voitProd && prod && <div className="lg:col-span-2 min-w-0"><Productivite d={prod} periode={perProd} setPeriode={setPerProd} /></div>}
        </div>
      )}
    </div>
  );
}
